import React from 'react'

const Support = () => {
  return (
    <div className='p-4'>
        This section will come soon!!...
    </div>
  )
}

export default Support